<template lang="pug">
.configurated-item
  .row.device-name
    .cell.label
      span {{ $t('Device') }}
    .cell.value
      span {{ getFullDeviceNameByDesktopId(playitem.deviceDesktop) }}
  .row.path
    .cell.label
      span {{ $t('Path') }}
    .cell.value
      span {{ namedPathFromMediaIds(playitem.mediapath) }}
  .section-default-configs(v-if='this.defaultConfigsExist() && !itemHasConfiguration()')
    .row.config
      span {{ $t('Default Configuration:') }}
    .row.config(
      v-if='this.configs.medium',
      :class="{'dimmed': Object.keys(this.configs.playitem).length > 0 }"
    )
      .cell.label
        span {{ $t('Medium') }}
        p(v-if='Object.keys(this.configs.playitem).length > 0') {{ $t('(overriden by playitem)') }}
      .cell.value
        ConfigurationTable(:config='this.configs.medium', :schema='this.schema')
    .row.config(v-if='Object.keys(this.configs.playitem).length > 0')
      .cell.label
        span {{ $t('Playitem') }}
      .cell.value
        //- pre {{ this.configs.playitem }}
        ConfigurationTable(:config='this.configs.playitem', :schema='this.schema')
  .section-user-config(
      :class="{'item-has-configuration': itemHasConfiguration() }"
    )
    .subsection-set-configuration(v-if='itemHasConfiguration()')
      .row.header
        span.warning {{ $t('Your configuration:') }}
      .row.config
        .cell.label
        .cell.value
          ConfigurationTable(:config='this.configs.extensionPlayitemDeviceDesktopConfig.extensionConfig', :schema='this.schema')
    .subsection-edit-configuration
      el-button(type='success', size='mini', @click='openConfigEditor()')
        p
          span {{ $t('Set your configuration') }}
  .section-schema
  el-dialog(:close-on-click-modal="false", title='', :visible.sync='extensionConfigVisible', @close='closeConfigEditor()', append-to-body, width='60%')
    ExtensionConfigEditor(
      v-if='extensionConfigVisible',
      :playListItem="playitem",
      :deviceDesktopId="playitem.deviceDesktop",
      :mediumId="playitem.MediumId"
      :extensionConfigForDeviceDesktop='this.configs.extensionPlayitemDeviceDesktopConfig? this.configs.extensionPlayitemDeviceDesktopConfig.extensionConfig : null',
      @close='closeConfigEditor()'
    )

</template>

<script>
import Vue from 'vue'
import mediaUtilsMixin from '../../Common/mediaUtils.mixin'
import textUtilsMixin from '../../Common/textUtils.mixin'
import MediumIcon from '../../Common/MediumIcon'
import ExtensionConfigEditor from '../ExtensionConfigEditor'
import ConfigurationTable from './ConfigurationTable'

export default {
  props: ['playitem'],
  mixins: [mediaUtilsMixin, textUtilsMixin],
  components: {
    MediumIcon,
    ExtensionConfigEditor,
    ConfigurationTable
  },
  async created () {
    this.configs = await this.getConfigs(this.playitem)
  },
  watch: {
    foo: async function (newVal, oldVal) {
    }
  },
  data () {
    return {
      configs: undefined,
      extensionConfigVisible: false,
      schema: undefined
    }
  },
  methods: {
    openConfigEditor () {
      this.extensionConfigVisible = true
    },
    async closeConfigEditor () {
      this.configs = await this.getConfigs(this.playitem)
      this.extensionConfigVisible = false
    },
    async getConfigs (playitem) {
      const medium = this.$store.state.Medium.media_list.find(m => m.id === parseInt(playitem.MediumId))
      const extensionPlayitemDeviceDesktopConfig = (await Vue.axios.get(`devicedesktop/${playitem.deviceDesktop}?populate=extensionPlayitemDeviceDesktopConfigs`)).data.extensionPlayitemDeviceDesktopConfigs
        .find(epddc => epddc.path === playitem.path)

      const schema = (await Vue.axios.get(`file/${medium.File}?populate=Extension`)).data.Extension.configSchema.properties
      this.schema = schema
      return {
        extensionPlayitemDeviceDesktopConfig: extensionPlayitemDeviceDesktopConfig || null,
        playitem: this.playitem.playlistitemExtensionConfig,
        medium: medium.extensionConfig
      }
    },
    defaultConfigsExist () {
      if (!this.configs) return false
      if (!this.configs.medium && !(Object.keys(this.configs.playitem).length > 0)) return false
      // console.log(!this.configs.medium, !(Object.keys(this.configs.playitem).length > 0))
      console.log(this.configs.medium)
      return true
    },
    namedPathFromMediaIds (mediaIds) {
      const names = []
      const idsArr = mediaIds.split('/').slice(1)
      for (let id of idsArr) {
        names.push(this.$store.state.Medium.media_list.find(m => m.id === parseInt(id)).name)
      }
      return names.join(' / ')
    },
    itemHasConfiguration () {
      return this.configs && this.configs.extensionPlayitemDeviceDesktopConfig
    }
  },
  computed: {
  }
}
</script>
<style lang="scss">
@import "../../../../theme-m4b/src/common/var.scss";
.configurated-item {
  color: $--color-text-regular;
  width: 500px;
  max-height: 1500px;
  border: 2px solid #444444;
  border-radius: 10px;
  padding: 30px;
  margin: 50px;
  background-color: #0e0e0f;
  .section-default-configs {
    border-top: 1px solid $--color-text-regular;
    padding-top:10px;
  }
  .section-user-config {
    .header {
      margin-left: 10px;
      margin-top: 0px;
      margin-bottom: 10px;
    }
    &.item-has-configuration {
      border: 1px solid $--color-warning;
      background-color: rgba($--color-primary, 0.3);
    }
    margin: 0px;
    padding-top:10px;
    padding-bottom:10px;
    border-radius: 3px;
    .subsection-edit-configuration {
      text-align: center;
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
  .row {
    display: flex;
    min-height: 25px;
    &.device-name {
      font-weight: bold;
      text-transform: uppercase;
      font-size: $--font-size-big;
      margin-top: -15px;
      margin-bottom: 20px;
    }

    .label {
      width: 100px;
      color: $--color-text-secondary;
    }
  }
  .dimmed {
    opacity: 0.6;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Medium/OnlyOwnMedia/PlayItem.vue